/* import __COLOCATED_TEMPLATE__ from './card-block.hbs'; */
import {
  buildStripePaymentElement,
  buildStripeSetupModeElement,
} from 'client-portal/utils/stripe-payment-methods';
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './card-block.module.scss';

@classic
@classNames(styles.component)
export default class RequestInformationCardBlock extends Component {
  styles = styles;

  @service currentPractice;
  @service stripe;
  @service session;
  @service localeManager;

  @tracked stripeElement;

  // TODO: Currently only formats US 10-digit numbers to E.164. International numbers pass through as-is.
  formatPhoneForStripe(phone) {
    return phone?.length === 10 ? `+1${phone}` : phone;
  }

  didInsertElement() {
    super.didInsertElement(...arguments);

    if (this.session.canUsePaymentMethods) {
      if (!this.stripe?.stripe) {
        return;
      }
      this.elements = buildStripeSetupModeElement(this.stripe.stripe, {
        locale: this.localeManager.currentLocaleForStripe,
        currency: this.currentPractice.get('currency'),
        onBehalfOf: this.currentPractice.get('stripeConnectedAccountId'),
        featureStripeLinkPassthroughMode: this.currentPractice.get(
          'featureStripeLinkPassthroughMode'
        ),
      });
      let paymentElementOptions = {
        onReady: () => this.setPaymentElementLoaded(this.elements),
        featureStripeLinkPassthroughMode: this.currentPractice.get(
          'featureStripeLinkPassthroughMode'
        ),
      };

      if (this.currentPractice.get('featureStripeLinkPassthroughMode')) {
        if (this.contactEmail) paymentElementOptions.email = this.contactEmail;
        if (this.contactPhone)
          paymentElementOptions.phone = this.formatPhoneForStripe(this.contactPhone);

        if (this.contactFullName) {
          this.model.set('name', this.contactFullName);
        }
      }

      this.paymentElement = buildStripePaymentElement(this.elements, paymentElementOptions);
    }
  }
}
